import React from 'react'

const Contactus = () => {
  return (
    <>
      <h1>CONTACT US</h1>
      {/* <footer>


  <div className='timeshow'><span id="current-time"></span></div>

</footer> */}

    </>
   
  )
}

export default Contactus
